var _defs, _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoteWorkBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.641 10.804h11.91a3.24 3.24 0 013.24 3.24v21.688a3.24 3.24 0 01-3.24 3.24H6.379a3.24 3.24 0 01-3.24-3.24V14.044a3.24 3.24 0 013.24-3.24h11.096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.315 7.221l2.894-2.852c1.842-2.212 5.359-1.757 6.578.85 1.219 2.608-.687 5.598-3.565 5.593l-5.581-.009M17.533 7.282l-2.662-2.921c-1.842-2.212-5.359-1.757-6.578.85-1.219 2.608.687 5.598 3.565 5.593l5.581-.009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.762 24.048v4.804M11.03 29.667h20.196M13.371 29.667v-5.864l4.235-4.56 4.723 4.723v5.538"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 28.62,
    cy: 20.383,
    r: 2.809
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.067,
    cy: 10.804,
    r: 1.445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteWorkBenefit);
export default __webpack_public_path__ + "static/media/RemoteWorkBenefit.7d5238435fea9aca39b1757935f65aba.svg";
export { ForwardRef as ReactComponent };